export var reduxKey = '@@DISCORD';
//# sourceMappingURL=constants.js.map